// IANA identifiers a facility can pick
export const FACILITY_TIMEZONES: readonly string[] = [
   "America/Adak",
   "America/Anchorage",
   "America/Atikokan",
   "America/Bahia_Banderas",
   "America/Blanc-Sablon",
   "America/Boise",
   "America/Cambridge_Bay",
   "America/Cancun",
   "America/Chicago",
   "America/Chihuahua",
   "America/Ciudad_Juarez",
   "America/Creston",
   "America/Dawson",
   "America/Dawson_Creek",
   "America/Denver",
   "America/Detroit",
   "America/Edmonton",
   "America/Fort_Nelson",
   "America/Glace_Bay",
   "America/Goose_Bay",
   "America/Halifax",
   "America/Hermosillo",
   "America/Indiana/Indianapolis",
   "America/Indiana/Knox",
   "America/Indiana/Marengo",
   "America/Indiana/Petersburg",
   "America/Indiana/Tell_City",
   "America/Indiana/Vevay",
   "America/Indiana/Vincennes",
   "America/Indiana/Winamac",
   "America/Inuvik",
   "America/Iqaluit",
   "America/Juneau",
   "America/Kentucky/Louisville",
   "America/Kentucky/Monticello",
   "America/Los_Angeles",
   "America/Matamoros",
   "America/Mazatlan",
   "America/Menominee",
   "America/Merida",
   "America/Metlakatla",
   "America/Mexico_City",
   "America/Moncton",
   "America/Monterrey",
   "America/New_York",
   "America/Nome",
   "America/Ojinaga",
   "America/Phoenix",
   "America/Puerto_Rico",
   "America/Rankin_Inlet",
   "America/Regina",
   "America/Resolute",
   "America/Sitka",
   "America/St_Johns",
   "America/St_Thomas",
   "America/Swift_Current",
   "America/Tijuana",
   "America/Toronto",
   "America/Vancouver",
   "America/Whitehorse",
   "America/Winnipeg",
   "America/Yakutat",
   "Etc/UTC",
   "Europe/Amsterdam",
   "Europe/Helsinki",
   "Europe/London",
   "Pacific/Guam",
   "Pacific/Honolulu",
   "Pacific/Pago_Pago",
]
